{
  "connections": {
    "branch": "Branch",
    "corpus": "Corpus: {{name}}",
    "details": "Details",
    "empty": "This project has no source connections.",
    "host": "Runs on the PC of",
    "loading": "Loading source connections…",
    "none": "none yet",
    "policies": {"automatic": "Automatic", "on_demand": "On demand"},
    "policy": "Policy",
    "sample_one": "sample of {{count}}",
    "sample_other": "sample of {{count}}",
    "states": {
      "failed": "Update failed",
      "pending": "Update queued",
      "proposed": "Update awaiting review",
      "running": "Update Run running",
      "up_to_date": "Up to date",
      "update_available": "Update available",
      "waiting_for_approval": "Update waits for a tool's approval on the PC it runs on",
      "waiting_for_host": "Waiting for the DMW Connector of the PC it runs on to come online",
      "waiting_for_you": "Update waits for you"
    },
    "title": "Source connections",
    "updateNow": "Update now",
    "uploaded": "Uploaded to DMW",
    "versions": "Upstream at {{upstream}}, imported {{imported}}"
  },
  "corpus": {
    "allHidden": "All corpora are hidden. Tick one to list its documents.",
    "details": "Details of {{corpus}}",
    "latest": "Latest version",
    "latestLabelled": "Latest version {{version}}",
    "shortKeys": "Short form",
    "shown": "Corpora in the list"
  },
  "document": {
    "added": {
      "annotations": "Annotations",
      "edit": "Edit",
      "hideOthers": "Hide proposals and closed results",
      "loading": "Loading what was added…",
      "openItem": "Open",
      "openItemHint": "The annotation set's page",
      "openResult": "Open",
      "openResultHint": "The result these statements come from",
      "openResultNumbered": "Open {{number}}",
      "openReview": "Open its review",
      "openThread": "Open its Run",
      "otherVersion": "On",
      "proposeEdits": "Propose the changes",
      "showInText": "Show in the text",
      "showOthers_one": "Show {{count}} proposal or closed result",
      "showOthers_other": "Show {{count}} proposals and closed results",
      "statementCount_one": "{{count}} statement",
      "statementCount_other": "{{count}} statements",
      "statements": "Statements",
      "stopEditing": "Close the editor"
    },
    "conclusions": {"basedOn": "Based on", "title": "Conclusions"},
    "entities": {"mentions": "Mentions", "other": "Other"},
    "findingLatest": "Finding the latest version…",
    "loading": "Loading document…",
    "metadata": "Metadata",
    "noFullText": "This document has no full text.",
    "olderVersion": "Older version",
    "regest": {
      "acceptedCount_one": "{{count}} accepted",
      "acceptedCount_other": "{{count}} accepted",
      "dated": "dated {{years}}",
      "moreLines_one": "{{count}} more",
      "moreLines_other": "{{count}} more",
      "proposed": "Proposed",
      "proposedCount_one": "{{count}} proposed",
      "proposedCount_other": "{{count}} proposed",
      "textCount_one": "{{count}} text",
      "textCount_other": "{{count}} texts",
      "unnamed": "Not named",
      "unplaced": "Not in this text"
    },
    "startThread": "Start a Run with this document",
    "startThreadOnSegment": "Start a Run with this segment",
    "title": "{{documentKey}}",
    "unnamed": "Document"
  },
  "import": {
    "advanced": "Advanced",
    "asDocuments": "The files are uploaded, and a Run of the import process schema converts them. A curator reviews the result.",
    "asJsonLines": "A JSON Lines file is imported directly, as a new corpus version.",
    "blockers": {
      "chooseFiles": "Choose a file or a folder first.",
      "connectRepository": "Connect to the repository's host first.",
      "consentPrivate": "Confirm that you may share the private repository first.",
      "enterRemote": "Give the repository's address first.",
      "installApp": "Install DMW's App on the repository first.",
      "nameCorpus": "Name the corpus first.",
      "noContentYet": "This project has no content yet, so no import process schema. DMW gives every project the DMW library, with “Ingest text documents”; the server adds it at its next start.",
      "noImportWorkflow": "Choose a JSON Lines file or ask a project administrator to set up an import process schema.",
      "workflowsFailed": "The import process schemas could not be read; see the message above.",
      "workflowsLoading": "Looking for the import process schema…"
    },
    "button": "Import",
    "cloud": {
      "branch": "Branch",
      "interval": "Look for new commits",
      "intervals": {
        "asked": "Only when asked",
        "daily": "Every day",
        "hourly": "Every hour",
        "weekly": "Every week"
      },
      "policies": {"automatic": "Automatic", "on_demand": "On request"},
      "policy": "Updates",
      "policyHints": {
        "automatic": "Each new commit is imported in a Run.",
        "on_demand": "New commits wait until someone asks for them."
      },
      "private": {
        "checkAgain": "Check again",
        "checking": "Checking the repository…",
        "connect": "{{repository}} is private or does not exist. Connect {{provider}} so DMW can read it, then import again.",
        "connectAction": "Connect {{provider}}",
        "consent": "Everyone in this project may read what DMW copies from it, with its history. I may share it with them.",
        "installAction": "Install DMW's App",
        "not_configured": "If {{repository}} is private: {{provider}} connection not configured. A public repository imports as usual.",
        "not_visible": "Your {{provider}} connection cannot see {{repository}}. Install DMW's App on it, or check the address.",
        "ready": "{{repository}} is private. DMW reads it through your {{provider}} connection.",
        "reconnect": "Your {{provider}} connection needs to be made again before DMW can read {{repository}}.",
        "reconnectAction": "Connect {{provider}} again"
      },
      "remote": "Repository address",
      "remoteHint": "An https:// address; DMW only reads from it. A private GitHub repository is read through your own GitHub connection.",
      "submit": "Connect and run the import",
      "working": "Connecting and fetching… A large repository may take several minutes."
    },
    "corpus": "Corpus",
    "corpusName": "Corpus name",
    "files": "File or folder",
    "filesHint": "A JSON Lines file, or text documents: TXT, Markdown, HTML, DOCX, PDF.",
    "importing": "Importing…",
    "intro": "From this PC, or from a Git repository that DMW follows.",
    "kind": "Where from",
    "kindHints": {
      "cloud": "A Git repository that DMW follows",
      "local": "A file or a folder from this PC"
    },
    "kinds": {"cloud": "Cloud", "local": "Local"},
    "mode": "Import mode",
    "modes": {
      "replace_all": "Replace all: documents missing from the file are removed",
      "upsert": "Add and update: other documents stay"
    },
    "newCorpus": "New corpus…",
    "newCorpusName": "Name of the new corpus",
    "openTool": "Open the tool",
    "openToolHint": "See how it works; “Ask the agent” on its page makes a new version.",
    "openWorkflow": "Open the process schema",
    "otherProject": "This import was prepared in another project. Choose that project in the top bar to continue, or start the import again here.",
    "replaceSegmentation": "Replace the segmentation of this corpus (re-segments every document)",
    "result": {
      "connected": "“{{source}}” now updates “{{corpus}}”.",
      "connectedTitle": "Connected",
      "counts": "Added {{added}}, changed {{modified}}, removed {{removed}}, unchanged {{unchanged}}.",
      "documentsVersion": "The corpus is now at version {{version}}.",
      "firstFetch": {
        "failed": "The first fetch failed; the connection is saved. Check the address and the branch. A private repository can't be fetched yet: DMW reads only what anyone can read without signing in.",
        "fetched": "The first fetch arrived.",
        "unchanged": "The first fetch found no commits on this branch yet."
      },
      "open": "Open the documents",
      "segmentationChanged": "This version applies the new segmentation to every document.",
      "title": "Import done",
      "unchanged": "Nothing changed; the corpus stays at version {{version}}.",
      "uploadTitle": "Uploaded",
      "uploadUnchanged": "“{{source}}” already holds these files; there is nothing new to import.",
      "uploaded_one": "{{count}} file is now commit {{commit}} of “{{source}}”, for “{{corpus}}”.",
      "uploaded_other": "{{count}} files are now commit {{commit}} of “{{source}}”, for “{{corpus}}”."
    },
    "run": {
      "failed": "The import Run could not start; Source connections say why.",
      "open": "Open the Run",
      "started": "The import runs as a Run of the import process schema.",
      "starting": "Starting the import Run…",
      "unknown": "The import's Run appears under Source connections."
    },
    "segmentation": "Segmentation",
    "segmentationHint": "How documents split into segments, in the dmw-segmentation/1 format. Boundary patterns are RE2 regular expressions.",
    "segmentationInvalid": "This is not a JSON object. Check brackets, quotes and commas.",
    "submit": "Import",
    "submitRun": "Upload and run the import",
    "templates": {
      "flat": "One segment per document",
      "fromInput": "Segments from the converter",
      "headAndNumberedParts": "Head and numbered parts"
    },
    "title": "Import documents",
    "tool": "Tool: {{name}}",
    "workflow": "Import process schema",
    "workflowHint": "Runs in a Run: you review what it found there, and a curator merges the result.",
    "workflowPinned": "Uploads into this corpus run the process schema its first upload chose, in a Run."
  },
  "index": {
    "intro": "Pick a document to read it or start a Run on it.",
    "noCorpusAction": "Import documents",
    "noCorpusAskSomeone": "Ask a contributor of this project to import documents.",
    "noCorpusTitle": "This project has no corpus yet",
    "openList": "Open the document list"
  },
  "list": {
    "empty": "This corpus version has no documents.",
    "loadMore": "Load more",
    "noneFiltered": "No document in this corpus matches the filters.",
    "order": "Order",
    "orders": {"creation": "As imported", "key": "By key"},
    "title": "Documents",
    "titleWithCount_one": "{{count}} document",
    "titleWithCount_other": "{{count}} documents"
  },
  "navigation": {
    "next": "Next document",
    "previous": "Previous document",
    "random": "Random",
    "randomTitle": "Open a random document"
  },
  "pages": {
    "openPdf": "Open the PDF at {{pages}} (new tab)",
    "pdfOnly": "PDF p. {{pdf}}",
    "printed": "p. {{page}} (PDF {{pdf}})",
    "range": "{{first}} to {{last}}"
  },
  "segment": {"title": "Segment {{segmentPath}}", "wholeDocument": "Whole document"},
  "sidebar": {"noCorpus": "This project has no corpus yet."}
}
